/**
 * src/components/publico/Campo.jsx
 * Campo de formulario de las pantallas públicas.
 *
 * Las etiquetas van en minúscula normal, no en MAYÚSCULAS MONOESPACIADAS: ese
 * es el idioma del panel de administración interno, y en una pantalla que le
 * pide a un desconocido su email y una contraseña lee a herramienta de uso
 * propio, no a producto. El mono se reserva para las cifras, como en el resto.
 */
import { useState } from 'react'

export function Campo({
  etiqueta, tipo = 'text', valor, onChange, placeholder,
  autoComplete, name, disabled, ayuda, autoFocus, inputMode,
}) {
  const [foco, setFoco] = useState(false)
  const esPassword = tipo === 'password'
  const [verClave, setVerClave] = useState(false)

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '7px' }}>
      <label style={{ fontSize: 'var(--text-base)', color: 'var(--color-text-2)' }}>{etiqueta}</label>

      <div style={{
        display: 'flex', alignItems: 'center', gap: 'var(--space-3)',
        background: 'var(--color-surface-2)',
        border: `1px solid ${foco ? 'var(--color-accent)' : 'var(--color-border-2)'}`,
        borderRadius: 'var(--radius-md)', padding: '0 15px',
        transition: 'border-color 0.15s ease',
      }}>
        <input
          type={esPassword && verClave ? 'text' : tipo}
          name={name}
          autoComplete={autoComplete}
          inputMode={inputMode}
          value={valor}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          autoFocus={autoFocus}
          onFocus={() => setFoco(true)}
          onBlur={() => setFoco(false)}
          style={{
            flexGrow: 1, minWidth: 0,
            background: 'transparent', border: 'none', outline: 'none',
            // 16px y no menos: por debajo de eso Safari en iPhone hace zoom al
            // enfocar el campo y descoloca la página entera.
            padding: '14px 0', fontSize: '16px',
            fontFamily: 'var(--font-ui)', color: 'var(--color-text)',
          }}
        />

        {esPassword && (
          <button type="button"
                  onClick={() => setVerClave(v => !v)}
                  aria-label={verClave ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    background: 'none', border: 'none', cursor: 'pointer',
                    // 13px de padding sobre un icono de 18 = 44 px de zona
                    // tocable, que es el mínimo para un dedo.
                    color: 'var(--color-text-2)', padding: '13px', margin: '0 -13px 0 0',
                  }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6Z" />
              <circle cx="12" cy="12" r="2.6" />
              {verClave && <path d="m3 21 18-18" />}
            </svg>
          </button>
        )}
      </div>

      {ayuda && <p style={{ margin: 0, fontSize: 'var(--text-sm)', color: 'var(--color-text-3)' }}>{ayuda}</p>}
    </div>
  )
}

/** Un error se dice donde se mira, no en un tono de consola. */
export function Aviso({ children }) {
  if (!children) return null
  return (
    <div style={{
      display: 'flex', gap: '10px', alignItems: 'flex-start',
      background: 'rgba(255, 94, 94, 0.08)',
      border: '1px solid rgba(255, 94, 94, 0.28)',
      borderRadius: 'var(--radius-md)', padding: '11px 13px',
      fontSize: 'var(--text-base)', color: 'var(--color-error)', lineHeight: 1.45,
    }}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
           style={{ flexShrink: 0, marginTop: '1px' }} aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 8v5" />
        <path d="M12 16.5h.01" />
      </svg>
      <span>{children}</span>
    </div>
  )
}
